import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from './primeng.module';
import {
  SomenteAlfanumericoDirective,
  SomenteNumerosDirective,
  SomenteLetrasDirective,
  SomenteDataDirective,
  CpfValidoDirective,
  CelularValidoDirective,
  EmailValidoDirective,
  CnpjValidoDirective,
  RgValidoDirective,
  FormatarDataDirective,
  CnpjCpfTextoDirective,
  PlacaTextoDirective,
  EmailGovValidoDirective,
} from './directives/mascaras.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { UploadArquivoComponent } from './componentes/upload-arquivo/upload-arquivo.component';
import { RouterLink } from '@angular/router';
import { TemPermissaoDirective } from './directives/permissoes.directive';
import { BreadcrumbComponent } from './componentes/breadcrumb/breadcrumb.component';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    UploadArquivoComponent,
    ReactiveFormsModule,
    PrimengModule,
    SomenteAlfanumericoDirective,
    SomenteNumerosDirective,
    SomenteLetrasDirective,
    SomenteDataDirective,
    CpfValidoDirective,
    RgValidoDirective,
    CnpjValidoDirective,
    CelularValidoDirective,
    EmailValidoDirective,
    RouterLink,
    FormatarDataDirective,
    CnpjCpfTextoDirective,
    PlacaTextoDirective,
    EmailGovValidoDirective,
    TooltipDirective,
    TemPermissaoDirective,
    BreadcrumbComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    UploadArquivoComponent,
    ReactiveFormsModule,
    PrimengModule,
    SomenteAlfanumericoDirective,
    SomenteNumerosDirective,
    SomenteLetrasDirective,
    SomenteDataDirective,
    CpfValidoDirective,
    CnpjValidoDirective,
    RgValidoDirective,
    CelularValidoDirective,
    EmailValidoDirective,
    RouterLink,
    FormatarDataDirective,
    CnpjCpfTextoDirective,
    PlacaTextoDirective,
    EmailGovValidoDirective,
    TooltipDirective,
    TemPermissaoDirective,
    BreadcrumbComponent
  ],
})
export class SharedModule { }
